<div class="flex flex-col" style="height: 100%; width: 350px;">
  <div class="plan_dialog--dimensions dialog-content flex flex-col" style="flex: 1; min-height: 0;">

    <!-- Panel Header -->
    <div class="dialog-header">
      <div class="dialog-header-left">
        <mat-icon class="dialog-header-icon">event_note</mat-icon>
        <span class="dialog-title">
          TIME ENTRY - PLAN · {{ isEditMode ? 'EDIT' : 'NEW' }}
        </span>
      </div>

      <div class="dialog-header-right">
        <mat-icon class="location-pin-icon">location_on</mat-icon>
        <span class="location-label">{{ consultantWorkCountry }}</span>
        <button
          type="button"
          class="dialog-close-btn"
          (click)="cancel()"
          aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <form [formGroup]="form" class="flex flex-col" style="flex: 1; min-height: 0;">

      <!-- Scrollable Field Area -->
      <div class="form-fields" style="flex: 1; overflow-y: auto; padding-right: 16px;">

        <!-- CLIENT -->
        <div class="client-field">
          <ng-select
            [items]="clients"
            bindLabel="ClientDescription"
            bindValue="Client"
            formControlName="client"
            placeholder="Select Client"
            appendTo="body"
            dropdownPosition="auto">
          </ng-select>
        </div>

        <!-- PROJECT -->
        <ng-select
          [items]="projects"
          bindLabel="Project_Label"
          bindValue="Project"
          formControlName="project"
          placeholder="Select Project"
          appendTo="body"
          dropdownPosition="auto">
        </ng-select>

        <!-- CONSULTANT -->
        <ng-select
          [items]="employees"
          bindLabel="FullName"
          bindValue="Employee"
          formControlName="employee"
          placeholder="Select Consultant"
          appendTo="body"
          dropdownPosition="auto">
        </ng-select>

        <!-- COMPANY -->
        <ng-select
          [items]="companies"
          bindLabel="Company_Name"
          bindValue="Company_Name"
          formControlName="company"
          placeholder="Select Company"
          appendTo="body"
          dropdownPosition="auto">
        </ng-select>

        <!-- TASK REF -->
        <ng-select
          [items]="taskRefs"
          bindLabel="Display_String"
          bindValue="Task_name"
          formControlName="taskRef"
          placeholder="Select Task.Ref"
          appendTo="body"
          dropdownPosition="auto">
        </ng-select>

        <!-- TASK -->
        <div class="text-field floating-field">
          <input
            matInput
            formControlName="task"
            type="text"
            placeholder=" "
            class="dialogInput"
            id="taskInput" />
          <label for="taskInput">Task</label>
        </div>

        <!-- HOURS -->
        <div class="hours-section">
          <div class="hours-line">
            <label>How many hours ?</label>

            <div class="hours-input-row">
              <input
                matInput
                formControlName="hours"
                max="24"
                min="0"
                step="0.5"
                type="number"
                class="dialogInput hours-input" />
            </div>

            <mat-radio-group
              formControlName="hourMode"
              (change)="setHoursForMode()"
              class="hour-radio-group">
              <mat-radio-button *ngFor="let mode of hourModes" [value]="mode">
                <span>{{ mode }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div
            class="field-error"
            *ngIf="form.controls.hours.invalid && (form.controls.hours.touched || form.controls.hours.dirty)">
            Hours must be at least 0.5.
          </div>
        </div>

        <!-- DATE -->
        <div class="date-field">
          <label>On which date ?</label>
          <div class="date-container">
            <input
              matInput
              [matDatepicker]="picker"
              [matDatepickerFilter]="weekdayFilter"
              formControlName="date"
              class="dialogInput"
              readonly
              (click)="picker.open()" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker
              #picker
              panelClass="add-plan-date-picker"
              (opened)="onDatepickerOpened('entry')"
              (closed)="onDatepickerClosed()">
            </mat-datepicker>
          </div>
        </div>

        <!-- INVOICE SAME DATE -->
        <div class="toggle-section">
          <mat-slide-toggle
            (change)="invoiceOnSameDate = !invoiceOnSameDate"
            [checked]="invoiceOnSameDate">
            <span>Invoice on same date</span>
          </mat-slide-toggle>
        </div>

        <!-- INVOICE DATE -->
        <div *ngIf="!invoiceOnSameDate" class="invoice-date-field">
          <label>Invoice on ?</label>
          <div class="date-container">
            <input
              matInput
              [matDatepicker]="invoicePicker"
              [matDatepickerFilter]="weekdayFilter"
              formControlName="invoiceDate"
              class="dialogInput"
              readonly
              (click)="invoicePicker.open()" />
            <mat-datepicker-toggle matIconSuffix [for]="invoicePicker"></mat-datepicker-toggle>
            <mat-datepicker
              #invoicePicker
              panelClass="add-plan-date-picker"
              (opened)="onDatepickerOpened('invoice')"
              (closed)="onDatepickerClosed()">
            </mat-datepicker>
          </div>
        </div>

        <!-- RATE -->
        <ng-select
          [items]="rates"
          bindLabel="Display_Rate"
          [compareWith]="compareRates"
          [loading]="ratesLoading"
          formControlName="rate"
          placeholder="Select Rate"
          appendTo="body"
          dropdownPosition="auto">
        </ng-select>

        <!-- ALLOCATE -->
        <div class="option-section">
          <span class="option-label">Allocate</span>
          <mat-radio-group formControlName="allocation" class="option-radio-group">
            <mat-radio-button value="Partial"><span>Partial</span></mat-radio-button>
            <mat-radio-button value="Full"><span>Full</span></mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- CHARGE -->
        <div class="option-section">
          <span class="option-label">Is entry chargeable?</span>
          <mat-radio-group formControlName="charge" class="option-radio-group">
            <mat-radio-button [value]="'Yes'" [disabled]="isProjectNonChargeable">
              <span>Yes</span>
            </mat-radio-button>
            <mat-radio-button [value]="'No'">
              <span>No</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- SAVE SELECTION -->
        <div class="toggle-section" style="justify-content: space-between;">
          <mat-slide-toggle
            [(ngModel)]="saveSelection"
            [ngModelOptions]="{ standalone: true }">
            <span>Save Selection</span>
          </mat-slide-toggle>

          <button
            mat-raised-button
            type="button"
            (click)="clearSelection()"
            class="font entry_button--design p-2 button-popup-css clear-selection-btn">
            Clear Selection
          </button>
        </div>

        <!-- REPEAT -->
        <div class="repeat-section">
          <div class="repeat-accordion-header" (click)="toggleRecurrenceExpanded()">
            <span class="chevron" [class.expanded]="recurrenceExpanded">▶</span>
            <span class="accordion-title">Repeat this entry</span>
            <span class="accordion-summary" *ngIf="form.controls.repeatEntry.value">
              {{ recurrenceSummary }}
            </span>
          </div>

          <div *ngIf="recurrenceExpanded" class="recurrence-grid">

            <!-- PATTERN -->
            <div class="recurrence-block">
              <span class="option-label block-label">Pattern</span>
              <mat-radio-group
                formControlName="recurrencePattern"
                (change)="onDailyModeChange()"
                class="vertical-radio-group">
                <mat-radio-button value="Daily">
                  <span>Daily (weekdays)</span>
                </mat-radio-button>
                <mat-radio-button value="Weekly">
                  <span>Weekly</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- WEEKLY DAYS -->
            <div
              *ngIf="form.controls.recurrencePattern.value === 'Weekly'"
              class="recurrence-block">
              <span class="option-label block-label">Days</span>
              <div class="weekday-grid">
                <label *ngFor="let day of weekdays" class="weekday-checkbox">
                  <input
                    type="checkbox"
                    [checked]="isWeekdaySelected(day)"
                    (change)="toggleWeekday(day)" />
                  <span>{{ day }}</span>
                </label>
              </div>
            </div>

            <!-- RANGE -->
            <div class="recurrence-block">
              <span class="option-label block-label">Range</span>

              <mat-radio-group
                formControlName="rangeMode"
                (change)="onRangeModeChange()"
                class="vertical-radio-group range-group">

                <div class="range-row">
                  <mat-radio-button value="occurrences"></mat-radio-button>
                  <span class="range-text">End after</span>
                  <input
                    matInput
                    formControlName="occurrences"
                    type="number"
                    min="1"
                    class="dialogInput hours-input inline-number" />
                  <span class="range-text">occurrences</span>
                </div>

                <div class="range-row">
                  <mat-radio-button value="endBy"></mat-radio-button>
                  <span class="range-text">End by</span>
                  <span class="inline-date">
                    <input
                      matInput
                      [matDatepicker]="endByPicker"
                      [matDatepickerFilter]="weekdayFilter"
                      formControlName="endByDate"
                      class="dialogInput"
                      readonly
                      (click)="endByPicker.open()" />
                    <mat-datepicker-toggle matIconSuffix [for]="endByPicker"></mat-datepicker-toggle>
                    <mat-datepicker
                      #endByPicker
                      panelClass="add-plan-date-picker">
                    </mat-datepicker>
                  </span>
                </div>
              </mat-radio-group>

              <div class="field-error" *ngIf="isEndByBeforeStart">
                End date must be on or after the entry date.
              </div>

              <div
                class="field-error"
                *ngIf="form.controls.occurrences.invalid && (form.controls.occurrences.touched || form.controls.occurrences.dirty)">
                Occurrences must be at least 1.
              </div>
            </div>

            <!-- CALENDAR PREVIEW -->
            <div class="calendar-preview">
              <ng-container *ngIf="currentCalendarMonth as month">
                <div class="calendar-nav">
                  <button
                    type="button"
                    class="calendar-nav-btn"
                    (click)="prevMonth()"
                    [disabled]="!canGoPrevMonth"
                    aria-label="Previous month">
                    <mat-icon>chevron_left</mat-icon>
                  </button>

                  <span class="calendar-month-label">{{ month.label }}</span>

                  <button
                    type="button"
                    class="calendar-nav-btn"
                    (click)="nextMonth()"
                    [disabled]="!canGoNextMonth"
                    aria-label="Next month">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                </div>

                <div class="calendar-grid calendar-weekday-row">
                  <span
                    class="calendar-weekday-label"
                    *ngFor="let d of weekdays">
                    {{ d.charAt(0) }}
                  </span>
                </div>

                <div class="calendar-grid">
                  <span
                    *ngFor="let cell of month.cells"
                    class="calendar-cell"
                    [class.in-month]="cell.inMonth"
                    [class.out-month]="!cell.inMonth"
                    [class.highlighted]="cell.highlighted">
                    {{ cell.day }}
                  </span>
                </div>
              </ng-container>

              <div class="calendar-summary">
                <strong>Creates {{ previewDates.length }} entries</strong>
                <div class="calendar-range">
                  {{ previewDateRangeLabel }} · {{ previewTotalHours.toFixed(2) }} hrs
                </div>
                <div class="calendar-range">
                  Total cost: {{ previewTotalCost | number:'1.2-2' }} {{ previewCurrencyCode }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button
          mat-raised-button
          type="button"
          (click)="cancel()"
          class="font entry_button--design p-2 button-popup-css">
          Cancel
        </button>

        <button
          mat-raised-button
          type="button"
          (click)="addPlan()"
          [disabled]="!canSubmit"
          class="font entry_button--design p-2 button-popup-css enabled:cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          style="color: #6ac738">
          Apply
        </button>
      </div>

    </form>
  </div>
</div>